import { useMutation, useQuery } from '@tanstack/react-query';

import { type EidCategories, type UserDataKey } from '@pkg/types';

import { callGetUserData, callPutUserData } from '@app/client/resources/user-data.ts';
import { useAuthTokens } from '@app/store/zustand';

export function useGetUserData(key: UserDataKey) {
    const isAuthenticated = !!useAuthTokens((s) => s.token.access_token);
    return useQuery({
        queryKey: ['user-data', key],
        queryFn: () => callGetUserData({ key }),
        staleTime: Infinity,
        enabled: Boolean(isAuthenticated && key),
        select: (r) => {
            if (r?.ok) {
                return r.value.value;
            }
        },
    });
}

export function useSetUserData(key: UserDataKey) {
    return useMutation({
        mutationFn: (value: EidCategories[]) => callPutUserData({ key, value: { value } }),
    });
}
